import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ROUTES } from '@/constants/routes';
import { authStore } from '@/stores/AuthStore';
import AppLayout from '@/components/Layout/AppLayout/AppLayout';
import {
  AuthPhonePage,
  AuthCodePage,
  PartnersPage,
  ClientsPage,
  ClientDetailPage,
  AnalyticsPage,
  NotFound,
} from '@/pages';

const AuthGuard = observer(() => {
  if (!authStore.isAuthenticated) {
    return <Navigate to={ROUTES.AUTH_PHONE} replace />;
  }
  return <Outlet />;
});

const PrivateRoute = observer(({ children }: { children: React.ReactNode }) => {
  if (!authStore.isAuthenticated) {
    return <Navigate to={ROUTES.AUTH_PHONE} replace />;
  }
  return <AppLayout>{children}</AppLayout>;
});

const AppRouter = observer(() => {
  return (
    <Routes>
      {/* Redirect root to /partners */}
      <Route path="/" element={<Navigate to={ROUTES.PARTNERS} replace />} />

      {/* Public auth routes */}
      <Route path={ROUTES.AUTH_PHONE} element={<AuthPhonePage />} />
      <Route path={ROUTES.AUTH_CODE} element={<AuthCodePage />} />

      {/* Protected routes with layout */}
      <Route element={<AuthGuard />}>
        <Route
          path={ROUTES.PARTNERS}
          element={
            <PrivateRoute>
              <PartnersPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.CLIENTS}
          element={
            <PrivateRoute>
              <ClientsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.CLIENT_DETAIL}
          element={
            <PrivateRoute>
              <ClientDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path={ROUTES.ANALYTICS}
          element={
            <PrivateRoute>
              <AnalyticsPage />
            </PrivateRoute>
          }
        />
      </Route>

      {/* 404 */}
      <Route path={ROUTES.NOT_FOUND} element={<NotFound />} />
      <Route path="*" element={<Navigate to={ROUTES.NOT_FOUND} replace />} />
    </Routes>
  );
});

AppRouter.displayName = 'AppRouter';

export default AppRouter;
